import { Section } from "./shared";

export default function BudgetConstraintGap() {
  return <Section stage="Stage 4 — Evaluate Executability" title="Execution Readiness Transition">
    <p className="text-sm leading-6 text-slate-600">This transition connects the Capital Efficient Position to executable-candidate availability. Management-confirmed affordability, timing, ownership, dependencies, delivery capacity, and implementation limits remain necessary; the optimizer&apos;s analytical Available Capital envelope does not establish execution readiness.</p>
  </Section>;
}
